import memoize from 'lodash/memoize';

const baseURL = '/dataTransfer';

const getData = R.prop('data');

/**
 * @deprecated
 */
const getTransferList = () => axios.get(`${baseURL}/list`).then(getData);
const getTransferListV2 = () => axios.get(`${baseURL}/listV2`).then(getData);

/**
 * @deprecated
 */
const getSettingList = memoize((id) =>
    axios
        .get(`${baseURL}/destination/definition?destinationDefinitionId=${id}`)
        .then(getData)
);

const getSettingListV2 = memoize((name) =>
    axios
        .get(`${baseURL}/destination/definitionV2?destinationName=${name}`)
        .then(getData)
);

/**
 * @deprecated
 */
const getDestinationOptions = memoize(() => {
    return axios.get(`${baseURL}/destination/list`).then(getData);
});

const getDestinationOptionsV2 = memoize(() => {
    return axios.get(`${baseURL}/destination/listV2`).then(getData);
});

/**
 * @deprecated
 */
const addTransfer = (params) => {
    return axios.post(`${baseURL}/create`, params).then(getData);
};

const addTransferV2 = (params) => {
    return axios.post(`${baseURL}/createV2`, params).then(getData);
};

/**
 * @deprecated
 */
const deleteTransfer = (params) => {
    return axios.delete(`${baseURL}/delete`, { data: params }).then(getData);
};

const deleteTransferV2 = (params) => {
    return axios.delete(`${baseURL}/deleteV2`, { data: params }).then(getData);
};

/**
 * @deprecated
 */
const updateTransfer = (params) => {
    return axios.post(`${baseURL}/update`, params).then(getData);
};

const updateTransferV2 = (params) => {
    return axios.post(`${baseURL}/updateV2`, params).then(getData);
};

const triggerManualTransfer = (params) => {
    return axios.post(`${baseURL}/trigger`, params).then(getData);
};

/**
 * @deprecated
 */
const checkTransfer = (params) => {
    return axios.post(`${baseURL}/checkconnection`, params).then(getData);
};

const checkTransferV2 = (params) => {
    return axios.post(`${baseURL}/checkconnectionV2`, params).then(getData);
};

const getGssWithWriteAccess = (params) => {
    return axios.get(`${baseURL}/writeAccessGss/`, params).then(getData);
};

const getHistories = ({ page, offset, connectionId } = {}) => {
    return axios
        .get(`${baseURL}/jobHistory?connectionId=${connectionId}&page=300`)
        .then(getData);
};
const getHistoriesV2 = ({ page, offset, connectionId } = {}) => {
    return axios
        .get(
            `${baseURL}/jobHistoryV2?dataTransferSettingId=${connectionId}&pageSize=300`
        )
        .then(getData);
};

const notifyCustom = (params) => {
    return axios.post(`${baseURL}/create/notification`, params).then(getData);
};

const getCustomFields = (dataTransferId) => {
    return axios
        .get(`${baseURL}/custom-field`, { params: { dataTransferId } })
        .then(getData);
};

const createCustomField = (params) => {
    return axios.post(`${baseURL}/custom-field`, params).then(getData);
};

const deleteCustomField = (ids) => {
    return axios
        .delete(`${baseURL}/custom-field`, { data: { ids } })
        .then(getData);
};

const updateCustomField = (params) => {
    const { id } = params;
    return axios.patch(`${baseURL}/custom-field/${id}`, params).then(getData);
};

const updateCustomFieldsByStream = (params) => {
    const { id, fields } = params;
    return axios
        .put(
            id ? `${baseURL}/${id}/custom-field` : `${baseURL}/custom-field`,
            fields
        )
        .then(getData);
};

const checkQueryValidation = (params) => {
    return axios
        .post(`${baseURL}/custom-field/validate-query`, params)
        .then(getData);
};

const getCustomFieldTemplates = () => {
    return axios.get(`${baseURL}/custom-field/templates`).then(getData);
};

const getColumnTypes = (params) => {
    return axios.post(`${baseURL}/getColumnTypes`, params).then(getData);
};

const getCompatibility = ({ selectedDatasources, selectedBreakdowns }) => {
    return axios
        .post(`${baseURL}/compatibility`, {
            selectedDatasources,
            selectedBreakdowns,
        })
        .then(getData);
};

export default {
    getTransferList,
    getTransferListV2,
    getSettingList,
    getSettingListV2,
    getDestinationOptions,
    getDestinationOptionsV2,
    addTransfer,
    addTransferV2,
    deleteTransfer,
    deleteTransferV2,
    updateTransfer,
    updateTransferV2,
    checkTransfer,
    checkTransferV2,
    getGssWithWriteAccess,
    getHistories,
    notifyCustom,
    getCustomFields,
    createCustomField,
    deleteCustomField,
    updateCustomField,
    updateCustomFieldsByStream,
    checkQueryValidation,
    getCustomFieldTemplates,
    getHistoriesV2,
    triggerManualTransfer,
    getColumnTypes,
    getCompatibility
    
};
